import { useEffect, useRef, useState } from "react";
import { ChangeAlertCallbackType, ChangeLoaderCallbackType } from "../../../Root";
import { ManualCheckService } from "../../../../services/ManualCheckService";
import moment from "moment";
moment.locale("es");

export const useCustomerValidate = (changeAlert: ChangeAlertCallbackType, changeLoader : ChangeLoaderCallbackType, onClose: Function, afbClevelList: Function) => {
    const manualCheckService = useRef<ManualCheckService>();

    const [zPos, setZPos] = useState(45);
    const [form, setForm] = useState(null);
    const [error, setError] = useState("");
    // -------------------------------------------------
    const [title, setTitle] = useState("");
    const [names, setNames] = useState([]);
    const [disabled, setDisabled] = useState(true);
    const [attachDisabled, setAttachDisabled] = useState(false);
    const listClevelReason = [
        { key: "Pep + alto riesgo" },
        { key: "Cliente alto riesgo" },
        { key: "PEP" },
        { key: "No Pep + No Cliente alto riesgo" },
        { key: "No PEP" },
        { key: "No Cliente alto riesgo" },
        { key: "Abuso de la plataforma" },
    ];

    const agent = localStorage.session ? JSON.parse(localStorage.session) : {};

    const onStoreData = async (lead, flag) => {
        cleanForm();

        if (flag && lead) {
            let f = {
                uuid: lead["uuid"],
                status: "checked",
                lead: lead["lead"],
                agent_request: lead["agent_request"],
                agent_response: {
                    uuid: agent["uuid"],
                    email: agent["email"],
                    name: agent["name"],
                },
                result: {
                    status: flag,
                    reason: "",
                    comment: "",
                    files: []
                }
            }
            setForm(JSON.parse(JSON.stringify(f)));

            switch (flag) {
                case "approved":
                    setTitle("Aprobar Lead de Alto Riesgo");
                    break;
                case "rejected":
                    setTitle("Rechazar Lead de Alto Riesgo");
                    break;
            }
        }
    };

    const onHandelUpdate = async () => {
        changeLoader(true);
        setZPos(-1);

        const resp = await manualCheckService.current.afbClevelUpdate(form);
        if (resp?.data?.response === "OK") {
            changeAlert(true, "OK", "Validación ejecutada con éxito.");
            changeLoader(false);
            setZPos(45);
            onClose();
            await afbClevelList(1);
        } else {
            setZPos(45);
            changeLoader(false);
            changeAlert(true, "error", resp["message"] || resp["data"].message || "Error al ejecutar petición");
        }
    };

    const onSelectReason = (e) => {
        let f = form;
        f["result"]["reason"] = e.target.value;
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const onChangeComment = (e) => {
        let f = form;
        e.target.value && setDisabled(false);

        f["result"]["comment"] = e.target.value;
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const onFileLoad = async (e, file) => {
        let img = e.target.files[0];
        let reader = new FileReader();
        if (img) {
            reader.readAsDataURL(img);
            reader.onload = await ((binding) => {
                return async () => {
                    let f = form["result"]["files"];
                    let fr = form;
                    let n = names;
                    if (f.length < 4) {
                        let base64 = reader.result.toString();
                        let fileName = img.name;
                        f.push(base64);
                        n.push(fileName);
                        fr["result"]["files"] = f;
                        setForm(JSON.parse(JSON.stringify(fr)));
                        setNames(JSON.parse(JSON.stringify(n)));
                        setAttachDisabled(JSON.parse(JSON.stringify(f.length === 4 ? true : false)));
                    }
                };
            })(this);
        }
    };

    const onDeleteFile = (index) => {
        let f = form;
        let n = names;
        let newFiles = [];
        let newNames = [];
        for (let i = 0; i < f["result"]["files"].length; i++) {
            if (i !== index) {
                newFiles.push(f["result"]["files"][i]);
                newNames.push(n[i]);
            }
        }
        f["result"]["files"] = newFiles
        setForm(JSON.parse(JSON.stringify(f)));
        setNames(JSON.parse(JSON.stringify(newNames)));
        setAttachDisabled(JSON.parse(JSON.stringify(newFiles.length === 4 ? true : false)));
    };

    const cleanForm = () => {
        setError("");
        setTitle("");
        setNames([]);
        setDisabled(true);
        setAttachDisabled(false);
        setForm(null);
        setZPos(45);
    };

    useEffect(() => {
        manualCheckService.current = new ManualCheckService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        form,
        zPos,
        names,
        title,
        error,
        disabled, 
        listClevelReason,
        attachDisabled,
        onStoreData,
        onDeleteFile,
        onFileLoad,
        onSelectReason,
        onChangeComment,
        onHandelUpdate
    };
};
